import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** tailwind-aware class combiner (the shadcn convention). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function slugify(input) {
    return input
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 120);
}
export function truncate(text, max) {
    if (text.length <= max)
        return text;
    return `${text.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
}
export function formatDate(value, locale = 'en-US') {
    const d = typeof value === 'string' ? new Date(value) : value;
    return d.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
}
export function buildQueryString(params) {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === '')
            continue;
        search.set(key, String(value));
    }
    const s = search.toString();
    return s ? `?${s}` : '';
}
export function debounce(fn, ms) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    };
}
//# sourceMappingURL=index.js.map